export const quizLocales: { key: string; name: string }[] = [
    { key: 'en', name: 'EN - English' },
    { key: 'cn', name: 'CN - 中文' },
    { key: 'kr', name: 'KR - 한국어' },
    { key: 'fr', name: 'FR - Français' },
    { key: 'it', name: 'IT - Italiano' },
    { key: 'es', name: 'ES - Español' },
    { key: 'de', name: 'DE - Deutsch' },
    { key: 'pt', name: 'PT - Português' },
    { key: 'ja', name: 'JA - 日本語' },
    { key: 'tr', name: 'TR - Türkçe' },
    { key: 'ar', name: 'AR - العربية' },
    { key: 'nl', name: 'NL - Nederlands' },
    { key: 'he', name: 'HE - עִבְרִית' },
    { key: 'pl', name: 'PL - Polski' },
    { key: 'ru', name: 'RU - Русский' },
];
